import React from 'react'
import { Col, Grid, Row } from './react-bootstrap'

const dateFormat = new Intl.DateTimeFormat('it-IT').format

function Footer() {
  return (
    <Grid className="Filters">
      <Row>
        <Col sm={12}>
          Fonte: elaborazione Veneto Lavoro su dati Silv
          <br />
          Dati estratti il {dateFormat(new Date())}
          <br />© Veneto Lavoro
        </Col>
      </Row>
    </Grid>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/Footer.js